import React, {createRef, useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";
import {Modal as RBModal} from "react-bootstrap";
import moment from "moment";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  DatePicker,
  Select,
  Input,
  Modal,
  SelectActions,
  Icon,
} from "../../components";
import {axios, Globals} from "../../utils";
import PrinterIcon from "../../assets/icons/printer.png";
import AddIcon from "../../assets/icons/add.png";
import FilterIcon from "../../assets/icons/icono_filtro.png";
import CloseIcon from "../../assets/icons/icono_cerrar.png";
import CreateWithholding from "./create-withholding";

const COLUMNS = [
  "Fecha de\nfactura",
  "Empresa",
  "RIF",
  "Tipo\ncontribuyente",
  "N° de\nfactura",
  "N° de\ncontrol",
  "Concepto de\nretención",
  "Tipo de\nretención",
  "Total Factura/\nNota débito o\nCrédito (Bs)",
  "Monto\nExento\n(Bs)",
  "Monto Objeto\nde retención\n(Bs)",
  "Porcentaje\nde retención\n(%)",
  "Impuesto\ncausado\n(Bs)",
  "Sustraendo\n(Bs)",
  "Impuesto\nretenido\n(Bs)",
  "Total pagado\n(Bs)",
  "Acciones",
];

const mapTaxpayer = {
  1: "Ordinario",
  2: "Formal",
  3: "Ocasional",
  4: "Pasivo Especial",
};
const mapConcept = {1: "Productos", 2: "Servicios", 3: "MIXTA"};
const mapType = {1: "IVA", 2: "ISLR"};

class Withholdings extends React.Component {
  state = {
    header: COLUMNS,
    // filtros que se envían al backend
    form: {
      user_id: this.props.user.id,
      search: "",
      bill_number: "",
      since: "",
      until: "",
      taxpayer_type: "",
      concept: "",
      type: "",
      per_page: 15,
    },
    // opciones de selects
    taxpayer_types: [],
    types: [],
    concepts: [],
    conversion: 1,

    showFilters: false,
    createModal: false,
    page: 1,
    last_page: 1,
    data: [],

    loading: false,
  };

  abortController = new AbortController();
  debounce = createRef();

  componentDidMount() {
    this.bootstrap();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  bootstrap = async () => {
    await this.fetchFilters();
    await this.load(1);
  };

  fetchFilters = async () => {
    try {
      Globals.setLoading();
      const res = await axios.post("admin/orders/retentions/getfilters", {
        user_id: this.props.user.id,
      });
      if (res?.data?.result) {
        const {
          taxpayer_types = [],
          types = [],
          concepts = [],
          conversion = 1,
        } = res.data;
        this.setState({taxpayer_types, types, concepts, conversion});
      } else {
        Globals.showError(
          res?.data?.message || "Ha ocurrido un error cargando filtros",
        );
      }
    } catch (error) {
      console.error(error);
      Globals.showError();
    } finally {
      Globals.quitLoading();
    }
  };

  load = async (page = 1) => {
    const {form} = this.state;
    try {
      Globals.setLoading();
      const payload = {
        ...form,
        user_id: this.props.user.id,
      };
      const res = await axios.post(
        `admin/orders/retentions/get?page=${page}`,
        payload,
      );
      if (res?.data?.result) {
        const pagination = res.data.data;

        // --- DEPURACIÓN ---
        console.log("Respuesta completa backend:", res.data);
        console.log("Listado de retenciones:", pagination.data);

        // Buscar e inspeccionar una factura mixta (concept === 3)
        const mixta = pagination.data?.find((item) => item.concept === 3);
        if (mixta) {
          console.log("Objeto Factura Mixta encontrado:", mixta);
        }
        // ------------------

        this.setState({
          page,
          last_page: pagination.last_page || 1,
          data: pagination.data || [],
        });
      } else {
        Globals.showError(res?.data?.message || "Error listando retenciones");
      }
    } catch (error) {
      console.error(error);
      Globals.showError();
    } finally {
      Globals.quitLoading();
    }
  };
  change = async (value, target) => {
    await this.setState((s) => ({form: {...s.form, [target]: value}}));
    this.load(1);
  };

  reset = async () => {
    await this.setState((state) => ({
      ...state,
      form: {
        user_id: this.props.user.id,
        search: "",
        bill_number: "",
        since: "",
        until: "",
        taxpayer_type: "",
        concept: "",
        type: "",
        per_page: 15,
      },
      page: 1,
    }));
    await this.load(1);
  };

  close = () => {
    this.setState({createModal: false, showFilters: false});
  };

  closeCreateModal = () => {
    this.setState({createModal: false, showFilters: false});
    this.reset();
  };

  print = async () => {
    try {
      Globals.setLoading();
      const payload = {
        ...this.state.form,
        user_id: this.props.user.id,
        download: true,
      };
      const res = await axios.post(`admin/orders/retentions/get`, payload);
      if (res?.data?.result && res?.data?.url) {
        window.open(res.data.url);
      } else {
        Globals.showError(
          res?.data?.message || "Error al generar reporte de retenciones",
        );
      }
    } catch (error) {
      console.error(error);
      Globals.showError();
    } finally {
      Globals.quitLoading();
    }
  };

  download = async (item) => {
    console.log(item);
    try {
      const form = {
        user_id: this.props.user.id,
        retention_id: item.id,
      };

      const res = await axios.post("admin/orders/retentions/download", form);
      if (!res.data?.url) throw new Error();

      window.open(res.data.url);
    } catch (error) {
      console.log(error);
      Globals.showError(
        "Ocurrió un error al generar el PDF. Intente nuevamente.",
      );
    }
  };

  render() {
    const {
      data,
      page,
      last_page,
      showFilters,
      createModal,
      header,
      conversion,
    } = this.state;

    return (
      <Menu history={this.props.history}>
        {showFilters && (
          <RBModal
            tabIndex="0"
            size="lg"
            show
            onHide={this.close}
            backdropClassName="custom-modal-bd"
            contentClassName="custom-modal-content"
            visible
          >
            <RBModal.Body>
              <img
                src={CloseIcon}
                alt="Cerrar"
                className="close-btn"
                onClick={this.close}
              />
              <Filters
                userId={this.props.user.id}
                initial={this.state.form}
                taxpayer_types={this.state.taxpayer_types}
                types={this.state.types}
                concepts={this.state.concepts}
                onSearch={async (filters) => {
                  await this.setState((s) => ({
                    showFilters: false,
                    form: {...s.form, ...filters},
                  }));
                  this.load(1);
                }}
                onClose={this.close}
              />
            </RBModal.Body>
          </RBModal>
        )}

        {createModal && (
          <Modal title="Crear Retención" onClose={this.close} visible>
            <CreateWithholding
              onSuccess={() => this.load(this.state.page)}
              onClose={this.closeCreateModal}
            />
          </Modal>
        )}

        <Table
          data={data.length}
          title="Registro de retenciones"
          header={header}
          right={
            <div
              style={{display: "flex", justifyContent: "center", gap: "1rem"}}
            >
              <Button
                title="Filtrar"
                small="true"
                onClick={() => this.setState({showFilters: true})}
              >
                <img src={FilterIcon} alt="Filtrar" />
              </Button>
              <Button title="Imprimir" small="true" onClick={this.print}>
                <img src={PrinterIcon} alt="Imprimir" />
              </Button>
              <Button
                title="Nuevo"
                small="true"
                onClick={() => this.setState({createModal: true})}
              >
                <img src={AddIcon} alt="Nuevo" />
              </Button>
            </div>
          }
        >
          {data.map((i, idx) => {
            const billDate = i.bill_date
              ? moment(i.bill_date).format("DD-MM-YYYY")
              : "-";
            const empresa = i.client?.name || "-";
            const rif = i.client?.document || "-";
            const tipoContrib = mapTaxpayer[i.taxpayer_type] || "-";
            const nroFactura =
              i.bill_number ||
              i.order_bill?.bill_number ||
              i.order?.bill_number ||
              "-";
            const nroControl =
              i.control_number ||
              i.order_bill?.control_number ||
              i.order?.control_number ||
              "-";

            const concepto = mapConcept[i.concept] || "-";
            const tipo = mapType[i.type] || "-";

            // Tasa propia de esta retención (guardada al momento de crearla)
            const rate = Number(i.conversion || 1);

            const totalFactura = Globals.formatMiles(
              Number(i.invoice_total || 0) * rate,
            );
            const montoExento = Globals.formatMiles(
              Number(i.exempt_amount || 0) * rate,
            );
            const base = Globals.formatMiles(
              Number(i.taxable_base || 0) * rate,
            );

            // Porcentaje de retención: para IVA → iva_withheld_rate*100; para ISLR → islr_rate
            const porcentaje =
              i.type === 1
                ? Globals.formatMiles(Number(i.iva_withheld_rate || 0) * 100)
                : Globals.formatMiles(Number(i.islr_rate || 0));

            // Impuesto causado (Bs): iva_amount * tasa (o islr_amount si es ISLR)
            const impuestoCaus =
              i.type === 2
                ? Globals.formatMiles(Number(i.islr_amount || 0) * rate)
                : Globals.formatMiles(Number(i.iva_amount || 0) * rate);

            // Sustraendo (Bs)
            const sustraendo = i.sustraendo
              ? Globals.formatMiles(Number(i.sustraendo) * rate)
              : "";

            // Impuesto retenido (Bs): depende del tipo
            const impuestoRet =
              i.type === 1
                ? Globals.formatMiles(Number(i.iva_withheld_amount || 0) * rate)
                : Globals.formatMiles(Number(i.islr_amount || 0) * rate);

            // Total pagado:
            let showTotal = false;
            if (i.concept === 1 && i.type === 1) showTotal = true;
            if ((i.concept === 2 || i.concept === 3) && i.type === 2)
              showTotal = true;

            const totalPagado = showTotal
              ? Globals.formatMiles(Number(i.payable_total || 0) * rate)
              : "";

            return (
              <tr key={idx}>
                <td>{billDate}</td>
                <td>{empresa}</td>
                <td>{rif}</td>
                <td>{tipoContrib}</td>
                <td>{nroFactura}</td>
                <td>{nroControl}</td>
                <td>{concepto}</td>
                <td>{tipo}</td>
                <td align="right">{totalFactura}</td>
                <td align="right">{montoExento}</td>
                <td align="right">{base}</td>
                <td align="right">{porcentaje}</td>
                <td align="right">{impuestoCaus}</td>
                <td align="right">{sustraendo}</td>
                <td align="right">{impuestoRet}</td>
                <td align="right">{totalPagado}</td>
                <td>
                  {/* Acciones (ver/imprimir) */}
                  <Button
                    color="info"
                    title="Descargar"
                    small="true"
                    onClick={() => this.download(i)}
                  >
                    <Icon name="download" />
                  </Button>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={last_page}
          active={page}
          onChange={(pg) => this.load(pg)}
        />
      </Menu>
    );
  }
}

/**
 * Modal de filtros
 * - Busca por: cliente (name/document), N° factura (bill_number)
 * - Fecha (usa un solo datepicker => manda since & until con la misma fecha)
 * - Tipo de contribuyente / Concepto / Tipo de retención (desde API de filtros)
 */
const Filters = ({
  initial,
  onSearch,
  taxpayer_types = [],
  concepts = [],
  types = [],
}) => {
  const [form, setForm] = useState({
    search: initial.search || "",
    bill_number: initial.bill_number || "",
    date: initial.since ? moment(initial.since).toDate() : "",
    taxpayer_type: initial.taxpayer_type || "",
    concept: initial.concept || "",
    type: initial.type || "",
    per_page: initial.per_page || 15,
  });

  const change = (value, key) => setForm((s) => ({...s, [key]: value}));

  const reset = () => {
    const blank = {
      search: "",
      bill_number: "",
      date: "",
      taxpayer_type: "",
      concept: "",
      type: "",
      per_page: 15,
    };
    onSearch({
      ...blank,
      since: "",
      until: "",
    });
  };

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "0 1rem",
          padding: "1rem 2rem 0",
        }}
      >
        <div>
          <Input
            color=" "
            label="Buscar"
            className="filter"
            placeholder="Nombre o razón social, RIF"
            value={form.search}
            onChange={(e) => change(e.target.value, "search")}
          />
        </div>
        <div>
          <Input
            color=" "
            label="N° de factura"
            className="filter"
            value={form.bill_number}
            onChange={(e) => change(e.target.value, "bill_number")}
          />
        </div>
        <div>
          <DatePicker
            color="white"
            label="Fecha de factura"
            className="filter"
            value={form.date}
            onChange={(value) => change(value, "date")}
          />
        </div>

        <div>
          <Select
            color="white"
            label="Tipo de contribuyente"
            className="filter"
            value={form.taxpayer_type}
            onChange={(e) => change(e.target.value, "taxpayer_type")}
            options={[
              {value: "", label: "Todos"},
              ...taxpayer_types.map((t) => ({value: t.value, label: t.label})),
            ]}
          />
        </div>

        <div>
          <Select
            color="white"
            label="Concepto de retención"
            className="filter"
            value={form.concept}
            onChange={(e) => change(e.target.value, "concept")}
            options={[
              {value: "", label: "Todos"},
              ...concepts.map((t) => ({value: t.value, label: t.label})),
            ]}
          />
        </div>

        <div>
          <Select
            color="white"
            label="Tipo de retención"
            className="filter"
            value={form.type}
            onChange={(e) => change(e.target.value, "type")}
            options={[
              {value: "", label: "Todos"},
              ...types.map((t) => ({value: t.value, label: t.label})),
            ]}
          />
        </div>
      </div>

      <div style={{display: "flex", justifyContent: "space-around"}}>
        <Button
          className="btn-align-bottom btn-filter blue"
          style={{minWidth: 110, maxWidth: 110}}
          color=" "
          onClick={() => {
            const since = form.date
              ? moment(form.date).format("YYYY-MM-DD")
              : "";
            const until = form.date
              ? moment(form.date).format("YYYY-MM-DD")
              : "";
            onSearch({
              search: form.search,
              bill_number: form.bill_number,
              taxpayer_type: form.taxpayer_type,
              concept: form.concept,
              type: form.type,
              per_page: form.per_page,
              since,
              until,
            });
          }}
        >
          <span>Filtrar</span>
        </Button>
        <Button
          className="btn-align-bottom btn-filter"
          style={{minWidth: 110, maxWidth: 110, marginRight: 0}}
          color=" "
          onClick={reset}
        >
          <span>Limpiar</span>
        </Button>
      </div>
    </>
  );
};

export default connect((state) => ({user: state.user}))(Withholdings);
